import { RootState } from "../../../infrastructure/state/store";
import { isSomeCollectionLoadedAndOtherLoading } from "../handle-busy/selectors";

export const isErrorOccurred = (state: RootState) => state.activityHistoryCollections.error.length > 0;

const areCollectionsEmpty = (state: RootState) => {
  const collections = state.activityHistoryCollections.collections;

  return Object.values(collections).every((collection) => {
    return !collection.items || collection.items.length === 0;
  });
};
export const isAllDataFailedToLoad = (state: RootState) => {
  return !isSomeCollectionLoadedAndOtherLoading(state) && isErrorOccurred(state) && areCollectionsEmpty(state);
};

export const selectErrorMessages = (state: RootState) => state.activityHistoryCollections.error;
